module.exports = __webpack_public_path__ + "static/media/ic_score_notice.5cd7a415.png";